__turbopack_context__.v({
  "my_list": "MyPageContent-module-scss-module__Om2ZlG__my_list",
});
